import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { FluidModule } from 'primeng/fluid';
import { TooltipModule } from 'primeng/tooltip';
import { PasswordModule } from 'primeng/password';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { ClientViewModel } from '../viewmodels/client-viewmodel';
import { SelectModule } from 'primeng/select';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { ToastService } from 'src/app/toast/toast.service';
import { Router } from '@angular/router';
import { ClientService } from '../services/client.service';
import { AuthService } from '../../../auth/login/services/auth.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    Textarea,
    IconFieldModule,
    InputIconModule,
    SelectModule,
    FluidModule,
    TooltipModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    PasswordModule
  ],
  providers: [ClientViewModel, ConfirmationService, MessageService, ClientService]
})
export class ClientComponent implements OnInit {

  private http = inject(HttpClient);
  private fb = inject(FormBuilder);
  private messageService = inject(MessageService);
  private toastService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);
  private clientService = inject(ClientService);

  public viewModel!: ClientViewModel;
  @ViewChild('dt') dt!: Table;
  constructor() { }

  ngOnInit(): void {
    this.viewModel = new ClientViewModel(
      this.fb, 
      this.messageService, 
      this.toastService, 
      this.confirmationService, 
      this.router, 
      this.http, 
      this.clientService
    );
    this.viewModel.init();
  }

}
